/**
 * Resource Item Overlay
 */

const resourceNoAccessItems = [...document.querySelectorAll('.resource-item [data-has-access="false"]')];
if (resourceNoAccessItems.length) {
	const resourceItemOverlay = (item) => {
		item.addEventListener('mouseover', (e) => {
			const wrapper = e.target.closest('.resource-item__wrapper');
			wrapper.classList.add('selected');
		});

		item.addEventListener('mouseleave', (e) => {
			const wrapper = e.target.closest('.resource-item__wrapper');
			wrapper.classList.remove('selected');
		});
	};
	resourceNoAccessItems.map((item) => resourceItemOverlay(item));
}
